import React from "react";

const SVG = ({ style = {},
               fill = "#FFF",
               width = "100%",
               className = "",
               viewBox = "0 0 44 19"
             }) => (
    <svg
        width={width}
        style={style}
        height={width}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon ${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g clipPath="url(#clip0)">
            <path d="M39.2583 0C36.58 0 34.4655 2.10034 34.4655 4.76077V9.52154H32.5625V19.0431H37.3553C40.0336 19.0431 42.1481 16.9427 42.1481 14.2823V9.52154H44.0511V0H39.2583Z" fill={fill}/>
            <path d="M27.77 0C25.0917 0 22.9772 2.10034 22.9772 4.76077V9.52154H21.0742V0H16.2814C13.6031 0 11.4886 2.10034 11.4886 4.76077V9.52154H9.58558V0H4.79279C2.11447 0 0 2.10034 0 4.76077V9.52154H5.77954V19.0431H10.5723C13.2506 19.0431 15.3651 16.9427 15.3651 14.2823V9.52154H17.1977V19.0431H21.9904C24.6688 19.0431 26.7832 16.9427 26.7832 14.2823V9.52154H32.5628V0H27.77Z" fill={fill}/>
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="44" height="19" fill={fill}/>
            </clipPath>
        </defs>
    </svg>
);

export default SVG;


// WEBPACK FOOTER //
// ./src/assets/svg/logominSVG.js